export const ProjectsTranslations = {
  en: {
    projects: {
      title: "Performances",
      created: "Created:",
      draft: "No project",
      adopted: "In a project",
      filterAll: "All",
      filterDrafts: "No project",
      empty: "Nothing here yet.",
    },
  },

  es: {
    projects: {
      title: "Hojas de performance",
      created: "Creado:",
      draft: "Sin proyecto",
      adopted: "En un proyecto",
      filterAll: "Todos",
      filterDrafts: "Sin proyecto",
      empty: "Aquí no hay nada todavía.",
    },
  },
};
